export interface ReleaseFeature {
    kind: 'major'
    id: string
    title: string
    description: string
    route: string
    target: string
    image: string
    hint: string
}

// Mock announcements for entire pages or major product capabilities only.
export const releaseFeatures: ReleaseFeature[] = [
    {
        kind: 'major',
        id: 'truck-availability-report-page',
        title: 'Meet your Truck Availability Report.',
        description: 'Explore a dedicated reporting page for fleet availability, performance trends, and team activity.',
        route: '/truck-availability-report',
        target: '[data-testid="truck-report-header"]',
        image: '/onboarding/tour-reports.jpg',
        hint: 'Start here to explore the new Truck Availability Report page.',
    },
    {
        kind: 'major',
        id: 'fuel-ai-workspace',
        title: 'Meet your Fuel AI workspace.',
        description: 'Plan fuel stops and explore optimization tools in one dedicated workspace.',
        route: '/fuel-ai',
        target: '[data-testid="fuel-source-select"]',
        image: '/onboarding/tour-fleet.jpg',
        hint: 'Choose your fuel source to get started in the Fuel AI workspace.',
    },
]

interface PageFeatureTourDefinition {
    kind: 'minor'
    waitForEnabledTargets?: boolean
    id: string
    route: string
    steps: { target: string; title: string; content: string }[]
}

// Small page improvements use contextual tours, not announcement cards.
export const pageFeatureTours: PageFeatureTourDefinition[] = [
    {
        kind: 'minor',
        id: 'driver-import-preview',
        route: '/profiles/drivers',
        steps: [{ target: '[data-tour="add-driver-button"]', title: 'Add or import drivers', content: 'Add or import your drivers from here.' }],
    },
    {
        kind: 'minor',
        id: 'load-tools-preview-v2',
        waitForEnabledTargets: true,
        route: '/updater-agent/loads',
        steps: [
            { target: '[data-tour="upload-file-button"]', title: 'Upload a rate confirmation', content: 'Upload a rate confirmation here to get started.' },
            {
                target: '[data-tour="import-rate-cons"]',
                title: 'Import your rate confirmations',
                content: 'Use Import to bring rate confirmations into your workspace.',
            },
            { target: '[data-tour="manual-create"]', title: 'Create a load manually', content: 'Use Manual when you want to enter load details yourself.' },
        ],
    },
]
